/* import __COLOCATED_TEMPLATE__ from './items-list-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();